import React from 'react';
import './App.css';

const SAMPLE_TEXT = "The quick brown fox jumps over the lazy dog"
// const SAMPLE_TEXT = "test"

const App = () => (
  <TypingGame text={SAMPLE_TEXT} />
)

class TypingGame extends React.Component {
  constructor(props) {
    super(props)
    this.initialState = this.state = {
      curPos: 0,
      numErrors: 0,
      justMistyped: false
    };

    this.charTyped = this.charTyped.bind(this);
    this.reset = this.reset.bind(this);
  }

  reset() {
    this.setState(this.initialState);
  }

  charTyped(char) {
    if (char === this.props.text[this.state.curPos]) {
      this.setState(prevState => ({
        curPos: prevState.curPos + 1,
        justMistyped: false
      }));
    } else {
      this.setState(prevState => ({
        numErrors: prevState.numErrors + 1,
        justMistyped: true
      }));
    }
  }

  didPlayerFinish() {
    return this.state.curPos === this.props.text.length;
  }
   
  render() {
    return (
      <div className="TypingGame">
        <h1>React Typing Game!</h1>

        <TextToType
          text={this.props.text}
          pos={this.state.curPos}
          showErrorAnim={this.state.justMistyped}
          fadeBackground={this.didPlayerFinish()} />

        { !this.didPlayerFinish()
          ? <ControlledInputField
              charTyped={this.charTyped}
              exclamate={this.state.justMistyped} />
          : <RestartButton onClick={this.reset} />
        }
        
        <div className="status">
          <div>Number of errors: {this.state.numErrors}</div>
          <div>
            Time:
            <Stopwatch
              running={!this.didPlayerFinish()}
              reset={this.state.curPos === 0 && !this.state.justMistyped} />
          </div>
        </div>
      </div>
    );
  }
}

class TextToType extends React.Component {
  render() {
    const chars = [...this.props.text];
    const letters = chars.map((char, i) =>
      <Letter char={char} key={i} highlighted={this.props.pos === i} />
    );

    let cssClass = "TextToType";
    if (this.props.showErrorAnim) cssClass += " errorAnim";
    if (this.props.fadeBackground) cssClass += " disabled";

    return (
      <div className={cssClass}>
        {letters}
      </div>
    );
  }
}

class Letter extends React.Component {
  render() {
    let cssClass = "Letter";
    if (this.props.highlighted) cssClass += " highlighted";
    if (this.props.char === " ") cssClass += " space";

    return (
      <span className={cssClass}>
        {this.props.char}
      </span>
    );
  }
}

class ControlledInputField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      placeholderText: "Type here..."
    }

    this.focus = this.focus.bind(this);
    this.charTyped = this.charTyped.bind(this);
  }

  componentDidMount() {
    this.focus();
  }

  focus() {
    this.domInput.focus();
  }

  charTyped(event) {
    const char = event.target.value[0];

    this.props.charTyped(char);

    this.setState({
      inputValue: "",
      placeholderText: char
    });
  }

  render() {
    let ph = this.state.placeholderText.replace(/^ /, "_");
    if (this.props.exclamate) ph += " !!!";
    return (
      <input
        type="text"
        maxLength="1"
        value={this.state.inputValue}
        placeholder={ph}
        ref={i => this.domInput = i} // mete uma referencia ao <input> no this
        onChange={this.charTyped}
        onBlur={this.focus} />
    );
  }
}

class RestartButton extends React.Component {
  componentDidMount() {
    this.button.focus();
  }

  render() {
    return (
      <button className=".RestartButton"
              ref={b => this.button = b}
              onClick={this.props.onClick}>
        Restart
      </button>
    )
  }
}

class Stopwatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {seconds: 0};
    this.tick = this.tick.bind(this);
  }

  componentWillUnmount() {
    this.disarmTimer();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reset) {
      this.reset();
    }
    if (!this.isStopped(this.props) && this.isStopped(nextProps)) {
      this.disarmTimer();
    }
    if (this.isStopped(this.props) && !this.isStopped(nextProps)) {
      this.armTimer();
    }
  }

  isStopped(props) {
    return !props.running || props.reset;
  }

  armTimer() {
    this.timerID = setInterval(this.tick, 1000);
  }

  disarmTimer() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState((prevState) => ({seconds: prevState.seconds + 1}));
  }

  reset() {
    this.disarmTimer();
    this.setState({seconds: 0});
  }

  render() {
    let cssClass = "Stopwatch";
    if (this.isStopped(this.props)) cssClass += " disabled";
    return <span className={cssClass}>{this.state.seconds}</span>;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js